<template>
  <div class="home">
    <BackButton @click="goBack" />
    <div class="active_block" v-if="active">
      <div class="deposit_head">
        <img :src="active.img" class="currency_logo" />
        <span>{{ $t("deposit2") }} {{ active.name }}</span>
      </div>
      <div class="depositBlock">
        <input class="balance_block" v-model="selectedAmount" :placeholder="$t('depositPlaceholder') + currency" />
      </div>
      <span class="calculate_fiat">≈ {{ (selectedAmount / rate).toFixed(8) }} {{ active.symbol }}</span>
      <div class="balance_block lower">
        <span>{{ $t("paymentFromBalance") }}</span>
        <span v-if="isBalanceLoading">
          <BalanceSkeleton size="sm" />
        </span>
        <span v-else>{{ balance }} {{ currency }}</span>
      </div>
      <div class="timeAcceptButton" @click="buyAsset">{{ $t("deposit") }} {{ active.name }}</div>
    </div>
  </div>
  <Transition name="fade">
    <NotifyComponent :timely="false" :duration="3" :notify="notifyText" v-if="isShowNotify" @closeNotify="isShowNotify = false" />
  </Transition>
</template>
<script>
import { UserManager } from "@/utils/userManager";
import { translateApiError } from "@/utils/apiErrors";
import axios from "axios";
import { BackButton } from "vue-tg";
import NotifyComponent from "./NotifyComponent.vue";
import BalanceSkeleton from "./BalanceSkeleton.vue";

export default {
  components: {
    BackButton,
    NotifyComponent,
    BalanceSkeleton,
  },
  data() {
    return {
      user: null,
      botId: null,
      currency: this.$store.getters.getCurrency,
      active: null,
      selectedAmount: null,
      multi_fiat_value: null,
      rate: null,
      balance: null,
      isBalanceLoading: true,

      isShowNotify: false,
      notifyText: "",
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    async buyAsset() {
      if (!this.selectedAmount) return;
      if (this.selectedAmount > this.balance) {
        this.showNotify(this.$t("cash_null"));
        return;
      }
      try {
        const response = await axios.post(`${window.location.origin}/market/buy?bot_id=${this.botId}&user_id=${this.user.id}`, {
          asset: this.active.symbol,
          fiat_amount: this.selectedAmount,
        });
        console.log(response);
        this.showNotify(this.$t("assetBoughtSuccess"));
        this.getBalance();
      } catch (err) {
        console.log(err);
        this.showNotify(translateApiError(this.$t.bind(this), err.response?.data?.detail));
      }
    },
    showNotify(text) {
      this.notifyText = text;
      this.isShowNotify = true;
    },
    closeNotify() {
      this.isShowNotify = false;
    },
    fetchActives() {
      const actives = this.$store.getters.getActives;
      console.log(actives);
      const asset = this.$route.params.id.toUpperCase();
      this.active = actives.find((i) => i.symbol == asset);
      const multi_fiat_values = this.$store.getters.getMultiFiatValue;
      this.multi_fiat_value = multi_fiat_values.find((i) => i.symbol == asset);
      const currency = this.$store.getters.getCurrency;
      const key = `${currency.toLowerCase()}_value`;
      this.rate = this.multi_fiat_value.multi_fiat_value[key];
      console.log(this.rate);
    },
    getBalance({ silent = false } = {}) {
      if (!this.user || !this.botId) {
        console.error("Нет данных пользователя для запроса баланса");
        if (!silent) {
          this.isBalanceLoading = false;
        }
        return;
      }

      if (!silent) {
        this.isBalanceLoading = true;
      }

      axios
        .get(`${window.location.origin}/user/balance/${this.botId}/${this.user.id}`)
        .then((res) => {
          if (res.data && res.data.currencies) {
            this.balance = res.data.currencies[this.currency];
            this.$store.commit("setBalanceData", res.data);
          }
          this.isBalanceLoading = false;
        })
        .catch((err) => {
          console.log("БАЛАНС ОШИБКА", err);
          if (this.balance == null) {
            this.balance = 0;
          }
          this.isBalanceLoading = false;
        });
    },
    initializeUser() {
      const storedUser = this.$store.getters.getTgUserData;
      const storedBotId = this.$store.getters.getBotId;
      if (storedUser && storedBotId) {
        this.user = storedUser;
        this.botId = storedBotId;
      } else {
        const userContext = UserManager.getFullUserContext();
        this.user = userContext.user;
        this.botId = userContext.botId;
        this.$store.commit("setTgUserData", this.user);
        this.$store.commit("setBotId", this.botId);
      }
    },
  },
  mounted() {
    this.initializeUser();
    this.fetchActives();

    const cachedBalance = this.$store.getters.getBalanceData;
    if (cachedBalance?.currencies?.[this.currency] != null) {
      this.balance = cachedBalance.currencies[this.currency];
      this.isBalanceLoading = false;
      this.getBalance({ silent: true });
    } else {
      this.getBalance();
    }
  },
};
</script>
<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
  align-items: center;
  overflow-y: auto;
}
.active_block {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  width: 100%;
}
.deposit_head {
  font-size: 18px;
  font-family: "SF Pro Text Bold";
  display: flex;
  gap: 5px;
  align-items: center;
}
.deposit_head img {
  width: 20px;
}
.input {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: 17px;
  background-color: var(--button-background);
  border-radius: 10px;
  width: 100%;
}
.depositBlock {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.balance_block {
  width: 100%;
  background-color: var(--button-background);
  border-radius: 10px;
  border: 0;
  padding: 13px;
  font-size: 17px;
  font-weight: 400;
  outline: none;
  color: var(--text-color1);
}
.balance_block.lower {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 6px;
  padding: 15px;
}
.balance_block.lower span:nth-child(1) {
  font-size: 16px;
}
.balance_block.lower span:nth-child(2) {
  font-size: 18px;
  font-family: "SF Pro Text Bold";
  color: #007aff;
}
.calculate_fiat {
  align-self: flex-start;
  color: var(--black-to-white);
  opacity: 0.5;
  font-size: 17px;
}
.timeAcceptButton {
  background-color: #007aff;
  border-radius: 10px;
  padding: 15px;
  color: var(--button-text-color);
  border: 0;
  font-size: 16px;
  font-family: "SF Pro Text Bold";
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.3s;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.timeAcceptButton.active {
  opacity: 1;
}
</style>
